function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.85 3.68v-.11a2.55 2.55 0 00-.69-.81 3.69 3.69 0 00-.94-.52q-.52-.19-1-.35l-.79-.27a2.74 2.74 0 01-.64-.32 1.46 1.46 0 01-.5-.46 1.32 1.32 0 01-.16-.68V0A3.14 3.14 0 000 1.44a2.37 2.37 0 00.54.7 3.26 3.26 0 00.83.52 7.81 7.81 0 00.94.34l.9.3a3.43 3.43 0 01.79.36 1.67 1.67 0 01.51.51 1.38 1.38 0 01.19.75 1.79 1.79 0 010 .3 3.14 3.14 0 001.15-1.54z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5.85 5.22"
  }, props), _ref);
};

export default SvgComponent;